export default {
  title: 'Forudbestilling',
  categories: {
    title: 'Mest populære',
  },
  header: {
    pickup: 'Afhentning om 5 minutter',
  },
};
